module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Italic.5f8b1198.eot";